<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->


<template>
	<div>

		<!--		<div v-if="isDataLoading" v-loading="isDataLoading" element-loading-text="Loading Programs..." class="empty-loading-placeholder">-->

		<!--		</div>-->
		<div>
			<div class="col px-0">
				<div class="px-3 pb-4">
					<h4 style="font-weight: 500" class="mb-4">Setup your availability</h4>
					<p>Set your typical availability to get started. You can further customize it later on.</p>
				</div>

				<div class="col no-select">

					<div>
						<hr class="m-0 pb-5"/>

						<div class="mb-5">
							<h5 class="pb-2" style="font-size:1em; font-weight: 600">Available hours</h5>
							<el-form :model="form" :rules="rules" label-position="right" ref="mainForm"
									 class="w-100" @submit.native.prevent="submitForm()">
								<el-form-item prop="startTime" style="border: none" class="w-100">

									<div class="row justify-content-around vertical-center pb-2">
										<div class="cursor-pointer">
											<el-time-select
												placeholder="Start time"
												v-model="form.startTime"
												:editable="false"
												:clearable="false"
												:picker-options="startTimeOptions"
												@click.native="clearFormValidation">
											</el-time-select>
											<i class="fontello icon-angle-down"
											   style="position:relative; margin-left: -25px; z-index: 100000000; pointer-events: none"/>
										</div>
										&ndash;
										<div>
											<el-time-select
												placeholder="End time"
												v-model="form.endTime"
												:editable="false"
												:clearable="false"
												:picker-options="endTimeOptions"
												@click.native="clearFormValidation">
											</el-time-select>
											<i class="fontello icon-angle-down"
											   style="position:relative; margin-left: -25px; z-index: 100000000; pointer-events: none"/>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div class="mb-4">
							<h5 class="pb-2" style="font-size:1em; font-weight: 600">Available days</h5>
							<div class="justify-content-center px-3"
								 :class="{'vertical-center': smUp, row:smUp, col:!smUp}">
								<div v-for="(day, index) in days" :key="index" @click="onDayClicked(index)"
									 class="p-1 clickable hover" :class="{'text-center': smUp, col:smUp, row:!smUp}"
									 style="margin-left:-1px;margin-bottom:-1px;border: 1px solid #d0d0d0;">
									<el-checkbox v-model="day.isSelected" @change="onDayClicked(index)"
												 class="my-1 mx-2"></el-checkbox>
									<div><p style="font-size: 10px; font-weight: 500;" class="m-1">{{day.name}}</p>
									</div>
								</div>

							</div>
						</div>

					</div>


				</div>
			</div>

		</div>


	</div>
</template>

<script>

	import WizardBaseStep from "./WizardBaseStep"
	import moment from 'moment'
	import AvailabilitySettings from "@/core/js/model/scheduler/AvailabilitySettings";
	import {TimeInterval} from "@/core/js/model/scheduler/TimeInterval";
	import EventType from "@/core/js/model/scheduler/EventType";
    import {logError} from "@/utils/helpers";


	export default {
		extends: WizardBaseStep,
		components: {},
		data() {
			return {

				form: {
					startTime: '9:00',
					endTime: '17:00',
				},
				rules: {
					startTime: [
						{ validator:(rule, value, callback, source, options) => {
								let error;
								if(this.startTimeMs >= this.endTimeMs){
									error = 'End time must be after start time'
								}
								console.log("validator: error = ", error)
								return callback(error)
							},
							trigger: 'validate'
						}
					],

				},


				days: [
					{
						name: 'Sunday',
						isSelected: false
					},
					{
						name: 'Monday',
						isSelected: true
					},
					{
						name: 'Tuesday',
						isSelected: true
					},
					{
						name: 'Wednesday',
						isSelected: true
					},
					{
						name: 'Thursday',
						isSelected: true
					},
					{
						name: 'Friday',
						isSelected: true
					},
					{
						name: 'Saturday',
						isSelected: false
					}
				]

			};
		},
		computed: {
			smUp(){
				return true
			},
			wizardStepPercentage() {
				return this.step / this.stepCount * 100
			},
			startTimeOptions(){
				return {
					start: '00:00',
					step: '01:00',
					end: '22:00'
				}
			},

			endTimeOptions() {
				return {
					start: '01:00',
					step: '01:00',
					end: '23:00',
					minTime: this.form.startTime
				}
			},

			startTimeMs(){
				return new moment(this.form.startTime, "hh:mma")
			},
			endTimeMs(){
				return new moment(this.form.endTime, "hh:mma")
			}
		},
		created() {
		},
		methods: {
			onDayClicked(index) {
				console.log("onDayClicked: index = ", index)
				this.days[index].isSelected = !this.days[index].isSelected
			},

			onNextClicked(){
				this.$refs.mainForm.validate(isValid => {
					if (isValid){
						this.onFormValidated();
					}
				})
			},
			onFormValidated(){
				this.clearFormValidation()
				let eventType = new EventType();
                eventType.displayName = "Intake Appointment"
				eventType.displayId = "intake-appointment"
				eventType.duration = 90 * (60 * 1000);
				eventType.needsSetup = true
				eventType.coachId = this.ownerProfile.id
				let startTime = Math.floor(this.startTimeMs)
				let endTime = Math.floor(this.endTimeMs)
				let availabilitySettings = new AvailabilitySettings();
				this.userProfile.schedulerSettings.availabilitySettings = availabilitySettings;
				// let availabilitySettings = eventType.availabilitySettings;

				for(let i = 0; i < 7; ++i){
					if(this.days[i].isSelected){
						let intervals = availabilitySettings.byDayIndex(i);
						let interval = new TimeInterval(startTime, endTime)
						interval.setRelativeTime()
						intervals.push(interval)
					}
				}
				console.log("eventType = ", eventType)

				this.showProgress()
				return Promise.all(
					[
						this.$authManager.updateUserProfile(this.userProfile),
						this.$dataManager.createEventType(eventType, {ownerId: this.userProfile.id})//we override ownerId to make sure the eventType is created inside the logged in user and not inside the owner's account in case they are different.
					]
				)

					.then(this.onNextConfirmed)
					.catch(error => {
						this.handleError(error, "Something went wrong. Please try again later.")
						this.hideProgress();
					})

	},
			clearFormValidation(){
				this.$refs.mainForm.clearValidate();
			}


		},

	}
</script>

<style src="../Scheduler.scss" lang="scss" scoped/>
